<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 10.5C7.58579 10.5 7.25 10.8358 7.25 11.25C7.25 11.6642 7.58579 12 8 12C8.41421 12 8.75 11.6642 8.75 11.25C8.75 10.8358 8.41421 10.5 8 10.5ZM8 4C7.75454 4 7.55039 4.17688 7.50806 4.41012L7.5 4.5V9L7.50806 9.08988C7.55039 9.32312 7.75454 9.5 8 9.5C8.24546 9.5 8.44961 9.32312 8.49194 9.08988L8.5 9V4.5L8.49194 4.41012C8.44961 4.17688 8.24546 4 8 4Z" />
  </svg>
</template>
